/*
 * Copyright (c) 2021 AccelByte Inc. All Rights Reserved.
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import classnames from "classnames";
import styles from "./index.module.scss";
import { useEffect, useState } from "react";

interface SvgInlineProps {
  url: string;
  className?: string;
}

export const SvgInline = ({...props}: SvgInlineProps) => {
  const [svg, setSvg] = useState<string>("");
  const [isErrored, setIsErrored] = useState(false);

  useEffect(() => {
      fetch(props.url)
          .then(res => res.text())
          .then(setSvg)
          .catch(setIsErrored)
  }, [props.url]);

  return <span className={classnames(styles.inlineSvg, props.className, {[styles.hidden  as string]: isErrored})} dangerouslySetInnerHTML={{ __html: svg }} />;
}
